I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "about": {
    "company": {
      "description": "Независимый кредитный брокер, работающий в ваших интересах – мы сравниваем нескольких кредиторов, чтобы найти наиболее выгодное предложение.",
      "title": "Надежный Партнер на Вашей Стороне"
    },
    "expertise": {
      "description": "Без скрытых условий. Четко, понятно и эффективно – от заявки до одобрения.",
      "title": "Быстрые и Прозрачные Решения"
    },
    "location": {
      "title": "Как Нас Найти"
    },
    "security": {
      "description": "Мы тщательно храним вашу информацию и сотрудничаем только с лицензированными и проверенными партнерами.",
      "title": "Безопасность и Конфиденциальность Гарантированы"
    },
    "subtitle": "Мы работаем, чтобы предложить вам наиболее подходящее решение",
    "team": {
      "description": "Мы слушаем, понимаем и адаптируемся – решения, основанные на ваших потребностях, а не \"один размер для всех\".",
      "title": "Индивидуальный Подход к Каждому Клиенту"
    },
    "title": "О Нас"
  },
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Возникли ошибки: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Невозможно удалить запись, так как существуют зависимости: %{record}",
          "has_one": "Невозможно удалить запись, так как существует зависимость: %{record}"
        }
      }
    }
  },
  "anchor_links": {
    "about_us": "o-nas",
    "business": "biznes-kredit",
    "car": "avto-lizing",
    "consumer": "potrebitelskiy-kredit",
    "contact": "kontakty",
    "faq": "chasto-zadavaemye-voprosy",
    "loan_application_form": "forma-zayavki",
    "mortage": "ipoteka"
  },
  "contact": {
    "additional_info": "Наша команда готова помочь вам с любыми вопросами или проблемами.",
    "address": "Bukultu iela 11, Рига, Латвия",
    "address_title": "Адрес",
    "company_info": {
      "address": {
        "title": "Адрес",
        "value": "Bukultu iela 11, Рига, Латвия"
      },
      "bank": {
        "title": "A/S \"Luminor Bank\"",
        "value": "LV47RIKO0002930366834"
      },
      "email": {
        "title": "Эл. почта",
        "value": "info@kreditiem.lv"
      },
      "hours": {
        "title": "Часы Работы",
        "value": "Понедельник - Пятница: 8:00 - 17:00"
      },
      "name": {
        "title": "A/S Baltijas investīciju attīstības fonds",
        "value": "40103550907"
      },
      "phone": {
        "title": "Телефон",
        "value": "+371 251182216"
      },
      "title": "Информация о Компании"
    },
    "copyright": "© 2024 AS Baltijas investīciju attīstības fonds. Все права защищены.",
    "cta": "Связаться с Нами",
    "email": "info@kreditiem.lv",
    "email_title": "Эл. почта",
    "form": {
      "email": "Эл. почта",
      "message": "Сообщение",
      "message_placeholder": "Ваше сообщение...",
      "name": "Имя",
      "phone": "Номер Телефона",
      "sending": "Отправка...",
      "submit": "Отправить Сообщение",
      "surname": "Фамилия",
      "title": "Контактная Форма"
    },
    "hours_title": "Часы Работы",
    "hours_weekdays": "Понедельник - Пятница: 8:00 - 17:00",
    "hours_weekend": "Суббота - Воскресенье: Закрыто",
    "messages": {
      "error": "Не удалось отправить сообщение. Пожалуйста, попробуйте снова.",
      "success": "Сообщение успешно отправлено!"
    },
    "phone": "+371 251182216",
    "phone_title": "Телефон",
    "subtitle": "Свяжитесь с нашей командой",
    "title": "Контакты"
  },
  "contact_mailer": {
    "question": "Вопрос"
  },
  "cookie_consent": {
    "accept": "Принять все",
    "decline": "Отклонить",
    "message": "Мы используем файлы cookie для улучшения вашего опыта просмотра, предоставления персонализированного контента и анализа нашего трафика. Нажимая \"Принять все\", вы соглашаетесь на использование нами файлов cookie.",
    "privacy_policy": "Прочитайте нашу Политику конфиденциальности"
  },
  "date": {
    "abbr_day_names": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ],
    "abbr_month_names": [
      null,
      "янв.",
      "февр.",
      "марта",
      "апр.",
      "мая",
      "июня",
      "июля",
      "авг.",
      "сент.",
      "окт.",
      "нояб.",
      "дек."
    ],
    "day_names": [
      "воскресенье",
      "понедельник",
      "вторник",
      "среда",
      "четверг",
      "пятница",
      "суббота"
    ],
    "formats": {
      "default": "%d.%m.%Y",
      "long": "%-d %B %Y",
      "short": "%-d %b"
    },
    "month_names": [
      null,
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "few": "около %{count} часов",
        "many": "около %{count} часов",
        "one": "около %{count} часа",
        "other": "около %{count} часов"
      },
      "about_x_months": {
        "few": "около %{count} месяцев",
        "many": "около %{count} месяцев",
        "one": "около %{count} месяца",
        "other": "около %{count} месяцев"
      },
      "about_x_years": {
        "few": "около %{count} лет",
        "many": "около %{count} лет",
        "one": "около %{count} года",
        "other": "около %{count} лет"
      },
      "almost_x_years": {
        "few": "почти %{count} года",
        "many": "почти %{count} лет",
        "one": "почти %{count} год",
        "other": "почти %{count} лет"
      },
      "half_a_minute": "полминуты",
      "less_than_x_minutes": {
        "few": "меньше %{count} минут",
        "many": "меньше %{count} минут",
        "one": "меньше %{count} минуты",
        "other": "меньше %{count} минут"
      },
      "less_than_x_seconds": {
        "few": "меньше %{count} секунд",
        "many": "меньше %{count} секунд",
        "one": "меньше %{count} секунды",
        "other": "меньше %{count} секунд"
      },
      "over_x_years": {
        "few": "больше %{count} лет",
        "many": "больше %{count} лет",
        "one": "больше %{count} года",
        "other": "больше %{count} лет"
      },
      "x_days": {
        "few": "%{count} дня",
        "many": "%{count} дней",
        "one": "%{count} день",
        "other": "%{count} дней"
      },
      "x_minutes": {
        "few": "%{count} минуты",
        "many": "%{count} минут",
        "one": "%{count} минута",
        "other": "%{count} минут"
      },
      "x_months": {
        "few": "%{count} месяца",
        "many": "%{count} месяцев",
        "one": "%{count} месяц",
        "other": "%{count} месяцев"
      },
      "x_seconds": {
        "few": "%{count} секунды",
        "many": "%{count} секунд",
        "one": "%{count} секунда",
        "other": "%{count} секунд"
      },
      "x_years": {
        "few": "%{count} года",
        "many": "%{count} лет",
        "one": "%{count} год",
        "other": "%{count} лет"
      }
    },
    "prompts": {
      "day": "День",
      "hour": "Час",
      "minute": "Минута",
      "month": "Месяц",
      "second": "Секунда",
      "year": "Год"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "нужно подтвердить",
      "blank": "не может быть пустым",
      "confirmation": "не совпадает со значением поля %{attribute}",
      "empty": "не может быть пустым",
      "equal_to": "может иметь лишь значение, равное %{count}",
      "even": "может иметь лишь четное значение",
      "exclusion": "имеет зарезервированное значение",
      "greater_than": "может иметь значение большее %{count}",
      "greater_than_or_equal_to": "может иметь значение большее или равное %{count}",
      "in": "должно быть в диапазоне %{count}",
      "inclusion": "имеет непредусмотренное значение",
      "invalid": "имеет неверное значение",
      "less_than": "может иметь значение меньшее чем %{count}",
      "less_than_or_equal_to": "может иметь значение меньшее или равное %{count}",
      "model_invalid": "Возникли ошибки: %{errors}",
      "not_a_number": "не является числом",
      "not_an_integer": "не является целым числом",
      "odd": "может иметь лишь нечетное значение",
      "other_than": "должно отличаться от %{count}",
      "present": "нужно оставить пустым",
      "required": "не может отсутствовать",
      "taken": "уже существует",
      "too_long": {
        "few": "слишком большой длины (не может быть больше чем %{count} символа)",
        "many": "слишком большой длины (не может быть больше чем %{count} символов)",
        "one": "слишком большой длины (не может быть больше чем %{count} символ)",
        "other": "слишком большой длины (не может быть больше чем %{count} символа)"
      },
      "too_short": {
        "few": "недостаточной длины (не может быть меньше %{count} символов)",
        "many": "недостаточной длины (не может быть меньше %{count} символов)",
        "one": "недостаточной длины (не может быть меньше %{count} символа)",
        "other": "недостаточной длины (не может быть меньше %{count} символа)"
      },
      "wrong_length": {
        "few": "неверной длины (может быть длиной ровно %{count} символа)",
        "many": "неверной длины (может быть длиной ровно %{count} символов)",
        "one": "неверной длины (может быть длиной ровно %{count} символ)",
        "other": "неверной длины (может быть длиной ровно %{count} символа)"
      }
    },
    "template": {
      "body": "Проблемы возникли со следующими полями:",
      "header": {
        "few": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "many": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "one": "%{model}: сохранение не удалось из-за %{count} ошибки",
        "other": "%{model}: сохранение не удалось из-за %{count} ошибки"
      }
    }
  },
  "faq": {
    "contact_text": "Остались вопросы? Наша команда готова помочь.",
    "eligibility": {
      "answer": "После положительного решения по кредиту средства могут быть зачислены на ваш счет в течение нескольких часов или дней – в зависимости от выбранного кредитора и типа кредита.",
      "question": "Как быстро я могу получить деньги на свой счет?"
    },
    "process": {
      "answer": "Да, в некоторых случаях кредит с залогом или поручителем может увеличить шансы на получение финансирования или получение лучших условий.",
      "question": "Возможно ли получить кредит с поручителем или залогом?"
    },
    "requirements": {
      "answer": "Да, каждый случай оценивается индивидуально. Некоторые кредиторы также принимают альтернативные источники дохода – например, самозанятость или доход от аренды.",
      "question": "Могу ли я подать заявку, если я не официально трудоустроен?"
    },
    "subtitle": "Найдите ответы на распространенные вопросы о нашем кредитном процессе",
    "timeframe": {
      "answer": "Да, кредитная история учитывается, но мы работаем с несколькими кредиторами, включая тех, которые предлагают решения для клиентов с предыдущими отметками о просрочке.",
      "question": "Влияет ли мой кредитный рейтинг на шансы получить кредит?"
    },
    "title": "Часто Задаваемые Вопросы"
  },
  "features": {
    "description": "Мы помогаем найти не только лучшего кредитора, но и делаем весь процесс быстрым, понятным и безопасным – чтобы результат действительно соответствовал вашим потребностям.",
    "flexible_terms": {
      "description": "Выберите наиболее удобный срок сами",
      "title": "Гибкие Условия"
    },
    "great_rates": {
      "description": "Выберите то, что вам подходит",
      "title": "Прозрачность"
    },
    "personal_support": {
      "description": "Компетентные кредитные специалисты, которые помогут",
      "title": "Персональная Поддержка"
    },
    "quick_approval": {
      "description": "Получите ответ в течение 1 рабочего дня",
      "title": "Быстрое Одобрение"
    },
    "quick_process": {
      "description": "Получите решение в течение 1 рабочего дня",
      "title": "Быстрый Процесс"
    },
    "secure_process": {
      "description": "Ваши данные защищены на высшем уровне безопасности",
      "title": "Безопасный Процесс"
    },
    "title": "Почему Выбрать Нас?"
  },
  "floating_button": {
    "aria_label": "Перейти к форме заявки на кредит",
    "text": "Подать заявку"
  },
  "footer": {
    "business_hours": {
      "title": "Часы Работы",
      "weekdays": "Понедельник - Пятница: 8:00 - 17:00",
      "weekend": "Суббота - Воскресенье: Закрыто"
    },
    "contact": {
      "address": "Bukultu iela 11, Рига, Латвия",
      "address_title": "Адрес",
      "email": "info@kreditiem.lv",
      "email_title": "Эл. почта",
      "phone": "+371 25182216",
      "phone_title": "Телефон",
      "subtitle": "Свяжитесь с нашей командой",
      "title": "Свяжитесь с Нами"
    },
    "copyright": "© %{year} AS Baltijas investīciju un attīstības fonds. Все права защищены.",
    "disclaimer": "Объем полномочий - независимый брокер.",
    "legal": {
      "privacy": "Политика Конфиденциальности",
      "terms": "Условия Использования",
      "title": "Правовая Информация"
    },
    "quick_links": {
      "about": "О Нас",
      "contact": "Контакты",
      "faq": "ЧЗВ",
      "services": "Услуги",
      "title": "Быстрые Ссылки"
    },
    "social": {
      "title": "Мы в соцсетях"
    }
  },
  "form": {
    "and": "и",
    "buttons": {
      "next": "Далее",
      "previous": "Назад"
    },
    "documents_help": "Для оценки вашей заявки, пожалуйста, приложите банковские выписки за последние 6 месяцев.",
    "family_status": {
      "married": "Женат/Замужем",
      "single": "Холост/Не замужем"
    },
    "fields": {
      "addresses_match": "Мой фактический адрес совпадает с зарегистрированным",
      "agree_to_terms": "Я согласен с",
      "bank_account": "Номер Банковского Счета (IBAN)",
      "city": "Город / Поселок",
      "declared_address": "Зарегистрированный Адрес",
      "dependent_persons": "Количество Иждивенцев",
      "email": "Эл. почта",
      "factical_address": "Фактический Адрес",
      "family_status": "Семейное Положение",
      "first_name": "Имя",
      "job_type": "Тип Занятости",
      "last_name": "Фамилия",
      "loan_amount": "Сумма Кредита",
      "loan_period": "Срок Кредита",
      "loan_type": "Тип Кредита",
      "personal_code": "Личный Код",
      "phone": "Номер Телефона",
      "upload_documents": "Для ускорения рассмотрения заявки приложите выписку по банковскому счету"
    },
    "job_type": {
      "other": "Другое",
      "permanent": "Постоянная работа",
      "retired": "Пенсионер",
      "self_employed": "Самозанятый",
      "student": "Студент",
      "temporary": "Временная работа",
      "unemployed": "Безработный"
    },
    "links": {
      "privacy_policy": "Политика Конфиденциальности",
      "terms": "Условия Использования"
    },
    "loan_types": {
      "business": "Бизнес Кредит",
      "car": "Авто Лизинг",
      "consumer": "Потребительский Кредит",
      "mortgage": "Ипотека"
    },
    "messages": {
      "error": "Ошибка при отправке заявки: %{message}",
      "file_upload_error": "Ошибка при загрузке файла: %{message}",
      "file_upload_max": "Достигнуто максимальное количество файлов",
      "file_upload_removed": "Файл удален",
      "file_upload_size": "Размер файла превышает ограничение",
      "file_upload_success": "Файл успешно загружен",
      "file_upload_type": "Неверный тип файла",
      "loading": "Загрузка...",
      "network_error": "Ошибка сети. Пожалуйста, попробуйте снова.",
      "processing": "Обработка вашей заявки...",
      "saving": "Сохранение...",
      "success": "Заявка успешно отправлена!",
      "success_subtitle": "Мы свяжемся с вами в ближайшее время",
      "uploading": "Загрузка файла..."
    },
    "months": "месяцев",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Введите ваш город",
      "personal_code": "123456-12345",
      "phone": "+371 12345678"
    },
    "sections": {
      "address_info": "Информация об Адресе",
      "banking_info": "Банковская Информация",
      "family_info": "Информация о Семье",
      "loan_details": "Информация о Кредите",
      "personal_info": "Личная Информация"
    },
    "steps": {
      "1": "Личная информация",
      "2": "Информация о кредите",
      "3": "Информация об адресе",
      "4": "Информация о семье",
      "5": "Банк и документы"
    },
    "submit": "Отправить Заявку",
    "title": "Подать Заявку!",
    "validation": {
      "address": "Пожалуйста, введите корректный адрес",
      "bank_account": "Неверный формат IBAN",
      "email": "Неверный формат электронной почты",
      "file_size": "Размер файла должен быть менее %{size}MB",
      "file_type": "Неверный тип файла. Разрешенные типы: %{types}",
      "max_amount": "Максимальная сумма кредита %{amount}€",
      "max_period": "Максимальный срок кредита %{period} месяцев",
      "min_amount": "Минимальная сумма кредита %{amount}€",
      "min_period": "Минимальный срок кредита %{period} месяцев",
      "personal_code": "Личный код должен быть в формате 123456-12345",
      "phone": "Телефон должен содержать только цифры",
      "required": "%{field} обязателен",
      "terms_required": "Вы должны согласиться с условиями использования",
      "too_long": "%{field} не должен превышать %{count} символов",
      "too_short": "%{field} должен содержать минимум %{count} символов"
    }
  },
  "header": {
    "logo": {
      "description": "Индивидуальные финансовые решения",
      "title": "Kreditiem.lv"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Выберите: "
    },
    "submit": {
      "create": "Создать %{model}",
      "submit": "Сохранить %{model}",
      "update": "Сохранить %{model}"
    }
  },
  "hero": {
    "cta": "Подать Заявку",
    "description": "Подайте заявку на финансирование и получите индивидуальное предложение в течение 24 часов!",
    "title": "Индивидуальное предложение финансирования именно для вас"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "few",
        "many",
        "other"
      ]
    },
    "transliterate": {}
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский",
    "select_language": "Выбрать язык"
  },
  "loading": {
    "title": "Подайте заявку на финансирование и получите индивидуальное предложение в течение 24 часов!"
  },
  "loan_types": {
    "business": {
      "description": "До €250,000 на нужды вашего бизнеса",
      "title": "Бизнес Кредиты"
    },
    "car": {
      "description": "До €100,000 на новый автомобиль",
      "title": "Авто Лизинг"
    },
    "consumer": {
      "description": "До €20,000 на личные нужды",
      "title": "Потребительские Кредиты"
    },
    "mortgage": {
      "description": "До €500,000 на дом вашей мечты",
      "title": "Ипотека"
    },
    "title": "Виды кредитов"
  },
  "loan_types_page": {
    "benefits": {
      "title": "Преимущества"
    },
    "business": {
      "benefits": {
        "accessible": "Доступно - В течение действия договора получайте ответы на вопросы от своего консультанта",
        "convenient": "Удобно - Заключите сделку удаленно, не выходя из дома",
        "fast": "Быстро - Подпишите договор электронно с SMART-ID или электронной подписью",
        "pause": "Пауза - Возможна отсрочка платежа до шести месяцев",
        "profitable": "Выгодно - Верните кредит быстрее или получите дополнительную сумму при необходимости",
        "quality": "Качественно - Получите индивидуально адаптированный график платежей для вашего бизнеса"
      },
      "description": "Для существующих или будущих предпринимателей на оборотные средства, покупку рабочих материалов/оборудования или начало бизнеса.",
      "details": {
        "security": "Кредит выдается только под обеспечение недвижимостью.",
        "suitable": "Бизнес-кредит является подходящим решением для самозанятых лиц, планирующих начать или ведущих хозяйственную деятельность, фермерских хозяйств, а также предпринимателей, нуждающихся в оборотных средствах."
      },
      "faq": {
        "early_repayment": {
          "answer": "Да, кредит можно вернуть досрочно.",
          "question": "Можно ли вернуть кредит досрочно?"
        },
        "partial_funding": {
          "answer": "Для решения срочных деловых вопросов мы можем рассмотреть выдачу части финансирования в день подписания договора.",
          "question": "Можно ли получить часть кредита сразу?"
        },
        "purpose_check": {
          "answer": "Мы попросим вас проинформировать нас о цели использования кредита.",
          "question": "Будет ли проверяться цель использования кредита?"
        }
      },
      "period": "До 15 лет",
      "rate": "От 9% + EURIBOR в год",
      "security": "Недвижимость",
      "title": "Бизнес-кредит"
    },
    "car": {
      "benefits": {
        "accessible": "Доступно - В случае ремонта автомобиль ремонтируется в свободно выбранном официальном автосервисе",
        "convenient": "Удобно - Ежемесячный платеж включает арендную плату, КАСКО и ОСАГО"
      },
      "description": "Партнеры Kredītiem.lv предложат вам полный сервис автолизинга для новых или подержанных автомобилей. Этой услугой могут пользоваться как частные лица, так и предприниматели.",
      "details": {
        "full_service": "Партнеры Kredītiem.lv предлагают вам полный сервис автолизинга для новых или подержанных автомобилей. Этой услугой могут пользоваться как частные лица, так и предприниматели.",
        "partners": "Наши партнеры предлагают различные решения, включая приобретение автомобиля без первоначального взноса."
      },
      "faq": {
        "buyout": {
          "answer": "Да, вы можете выкупить автомобиль или вернуть его арендодателям.",
          "question": "Можно ли выкупить автомобиль после 3 лет аренды?"
        },
        "down_payment": {
          "answer": "Наши партнеры предлагают различные решения, включая приобретение автомобиля без первоначального взноса.",
          "question": "Нужен ли мне первоначальный взнос?"
        },
        "extension": {
          "answer": "Нет, вы не сможете продлить договор на конкретный автомобиль, его нужно будет выкупить или вернуть арендодателю (согласно заключенному договору), но вы можете выбрать новый автомобиль и заключить новую сделку.",
          "question": "Могу ли я продлить полный сервис автоаренды после 3 лет?"
        }
      },
      "period": "До 3 лет",
      "rate": "Без первоначального взноса",
      "security": "Полный сервис (OCTA + KASKO включены)",
      "title": "Автолизинг"
    },
    "consumer": {
      "benefits": {
        "accessible": "Доступно - Залог не требуется, рассмотрение от 15 минут",
        "convenient": "Удобно - Быстрое и простое решение для срочных вопросов, которые нельзя откладывать",
        "fast": "Быстро - Рассмотрение заявки от 15 минут",
        "pause": "Гибко - Различные сроки погашения от 3 месяцев до 10 лет",
        "profitable": "Выгодно - Конкурентные процентные ставки от 6,9%",
        "quality": "Качественно - Индивидуальное предложение, адаптированное к вашей ситуации"
      },
      "description": "Поддержка ваших планов - для крупных покупок, благоустройства дома, непредвиденных расходов, отпуска или различных ситуаций.",
      "details": {
        "security": "Залог не требуется. Сумма кредита от €100 до €20,000 с гибкими условиями погашения.",
        "suitable": "Потребительский кредит подходит, когда нужно быстро и удобно решить вопросы, которые нельзя откладывать. Идеален для крупных покупок, благоустройства дома, непредвиденных расходов, отпуска или различных жизненных ситуаций."
      },
      "faq": {
        "early_repayment": {
          "answer": "Да, досрочное погашение возможно без дополнительных комиссий.",
          "question": "Можно ли вернуть кредит досрочно?"
        },
        "partial_funding": {
          "answer": "Вы можете занять от €100 до €20,000 в зависимости от ваших доходов и кредитоспособности.",
          "question": "Какая минимальная и максимальная сумма кредита?"
        },
        "purpose_check": {
          "answer": "Потребительский кредит можно использовать для выбранных вами целей - мы не ограничиваем использование средств.",
          "question": "Будет ли проверяться цель использования кредита?"
        }
      },
      "period": "3 месяца - 10 лет",
      "rate": "От 6,9% в год",
      "security": "Залог не требуется",
      "title": "Потребительский кредит"
    },
    "cta": {
      "button": "Подать заявку сейчас",
      "description": "Начните свою заявку сегодня и получите индивидуальное предложение в течение 24 часов.",
      "title": "Готовы подать заявку?"
    },
    "details": {
      "title": "Подробная информация"
    },
    "faq": {
      "title": "Часто задаваемые вопросы"
    },
    "hero": {
      "description": "Выберите финансовое решение, которое лучше всего соответствует вашим потребностям. Мы предлагаем различные виды кредитов с конкурентными условиями и индивидуальным подходом.",
      "title": "Виды кредитов"
    },
    "how_to_apply": {
      "step1": {
        "description": "Заполните форму заявки и получите предложение по электронной почте",
        "title": "Заполните заявку"
      },
      "step2": {
        "description": "Подтвердите договор электронной подписью или получите его курьером",
        "title": "Подтвердите договор"
      },
      "step3": {
        "description": "Получите кредит на свой счет и направьте его на запланированную цель",
        "title": "Получите средства"
      },
      "title": "Как подать заявку"
    },
    "info": {
      "period": "Период",
      "rate": "Процентная ставка",
      "security": "Обеспечение"
    },
    "mortgage": {
      "benefits": {
        "accessible": "Доступно - В течение действия договора получайте ответы на вопросы от своего консультанта",
        "convenient": "Удобно - Заключите сделку удаленно, не выходя из дома",
        "fast": "Быстро - Подпишите договор электронно с SMART-ID или электронной подписью",
        "pause": "Пауза - Возможна отсрочка платежа до шести месяцев",
        "profitable": "Выгодно - Верните кредит быстрее или получите дополнительную сумму при необходимости",
        "quality": "Качественно - Получите индивидуально адаптированный график платежей для вашего бизнеса"
      },
      "description": "Кредит под залог недвижимости. Для приобретения недвижимости, рефинансирования существующих кредитов или залога существующей недвижимости.",
      "details": {
        "evaluation": "В данном случае стоимость залога определяется с помощью сертифицированного оценщика путем осмотра вашей недвижимости. В основном заявки на кредит впервые рассматриваются в течение 1 рабочего дня, предоставляя клиенту оперативный ответ о возможном одобрении кредита.",
        "processing": "Однако есть также случаи, когда необходима более углубленная оценка, которая может занять до 3-5 рабочих дней. В таких случаях клиент информируется по телефону о сроках оценки. Полученный кредит направляется на цель, указанную в заявке.",
        "suitable": "Кредит под залог недвижимости является подходящим решением для физических или юридических лиц, владеющих недвижимостью. Это долгосрочная сделка, обеспеченная залогом недвижимости. Кредит предоставляется клиенту в размере до 75% от стоимости залога и выдается лицам, достигшим возраста не менее 18 лет."
      },
      "faq": {
        "early_repayment": {
          "answer": "Да, кредит можно вернуть досрочно.",
          "question": "Можно ли вернуть кредит досрочно?"
        },
        "partial_funding": {
          "answer": "Для решения срочных деловых вопросов мы можем рассмотреть выдачу части финансирования в день подписания договора.",
          "question": "Можно ли получить часть кредита сразу?"
        },
        "purpose_check": {
          "answer": "Мы попросим вас проинформировать нас о цели использования кредита.",
          "question": "Будет ли проверяться цель использования кредита?"
        }
      },
      "period": "До 15 лет",
      "rate": "От 9% + EURIBOR в год",
      "security": "Недвижимость",
      "title": "Ипотека"
    }
  },
  "loan_use_cases": {
    "business_development": "Развитие бизнеса",
    "dream_vacation": "Путешествие мечты",
    "for_daily_use": "Повседневные расходы",
    "new_car": "Новый автомобиль",
    "perfect_home": "Идеальный дом"
  },
  "meta": {
    "contact_title": "Свяжитесь с Нами | Kreditiem.lv",
    "description": "Подайте заявку на кредит и узнайте свои финансовые возможности уже сегодня",
    "keywords": "кредит, ипотека, займ, финансирование, бизнес-кредит, потребительский кредит, сельскохозяйственный кредит",
    "loan_types_title": "Виды кредитов | Kreditiem.lv",
    "og_description": "Получите персонализированную финансовую поддержку с нашими проверенными финансовыми услугами",
    "og_title": "Kreditiem.lv - Индивидуальные Финансовые Решения",
    "title": "Заявка на Кредит"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "руб."
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "few": "миллиардов",
            "many": "миллиардов",
            "one": "миллиард",
            "other": "миллиардов"
          },
          "million": {
            "few": "миллионов",
            "many": "миллионов",
            "one": "миллион",
            "other": "миллионов"
          },
          "quadrillion": {
            "few": "квадриллионов",
            "many": "квадриллионов",
            "one": "квадриллион",
            "other": "квадриллионов"
          },
          "thousand": {
            "few": "тысяч",
            "many": "тысяч",
            "one": "тысяча",
            "other": "тысяч"
          },
          "trillion": {
            "few": "триллионов",
            "many": "триллионов",
            "one": "триллион",
            "other": "триллионов"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "few": "байта",
            "many": "байт",
            "one": "байт",
            "other": "байта"
          },
          "eb": "ЭБ",
          "gb": "ГБ",
          "kb": "КБ",
          "mb": "МБ",
          "pb": "ПБ",
          "tb": "ТБ"
        }
      }
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "routes": {
    "contact": "kontakty",
    "loan_types": "vidy-kreditov"
  },
  "support": {
    "array": {
      "last_word_connector": " и ",
      "two_words_connector": " и ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "утра",
    "formats": {
      "default": "%a, %d %b %Y, %H:%M:%S %z",
      "long": "%d %B %Y, %H:%M",
      "short": "%d %b, %H:%M"
    },
    "pm": "вечера"
  }
});
